<template>
  <el-drawer
    title="录音转文字"
    direction="rtl"
    show-close
    :size="520"
    :visible.sync="visible"
    :before-close="close"
    append-to-body
    custom-class="staff-drawer"
  >
    <div ref="chatContainer" class="chat-container h-full box-border w-full bg-theme-gray overflow-x-hidden overflow-y-auto p-4"  @scroll="handleScroll">
      <div v-if="!chatList.length" class="text-right">
        <i class="el-icon-loading"></i>
      </div>
      <template v-for="(item, index) in chatList">
        <div class="chat-item-wrap w-full mt-3" :class="{ 'show': item.show }"  :key="index" :style="{ 'animation-delay': `${index * 0.3}s` }">
          <!--  ${item.channel_id === (chatList && chatList[0] && chatList[0].channel_id) ? 'text-right' : ''} -->
          <!-- ${item.channel_id === (chatList && chatList[0] && chatList[0].channel_id) ? 'slide-in-right' : 'slide-in-left'} -->
          <p :class="`text-theme-black-650 text-small mb-1 `">{{item.time}}</p>
          <div :class="`chat-block ${item.channel_id === (chatList && chatList[0] && chatList[0].channel_id) ? 'chat-block-right slide-in-right' : 'slide-in-left'}`">
            <span>{{item.text}}</span>
          </div>
        </div>
      </template>
    </div>
  </el-drawer>
</template>

<script>
import { audioToText } from '@/api/wenjuan/answerList'

export default {
  name: '',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    toTextItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      chatList: [],
      timers: [],
      isAutoScroll: true,
      scrollThreshold: 50 // 距离底部的阈值，单位像素
    }
  },
  computed: {
    visible: {
      set(v) {
        this.$emit('update:show', v)
      },
      get() {
        if(this.show) {
          this.chatList = []
          this.isAutoScroll = true
          this.audioToText()
        }
        return this.show
      }
    }
  },
  created() {
    
  },
  methods: {
    close() {
      this.visible = false
      this.clearAllTimers()
    },
    formatMilliseconds(milliseconds) {
      const totalSeconds = Math.floor(milliseconds / 1000);
      
      // 计算小时、分钟、秒
      const hours = Math.floor(totalSeconds / 3600);
      const remainingSeconds = totalSeconds % 3600;
      const minutes = Math.floor(remainingSeconds / 60);
      const seconds = remainingSeconds % 60;

      // 智能格式判断
      const parts = [];
      if (hours > 0) {
        parts.push(String(hours).padStart(2, '0'));
        parts.push(String(minutes).padStart(2, '0'));
      } else {
        // 当小时为0时，允许分钟超过59（如 6000秒 -> 100分钟）
        parts.push(String(minutes + hours * 60).padStart(2, '0'));
      }
      parts.push(String(seconds).padStart(2, '0'));

      return parts.join(':');
    },
    audioToText() {
      audioToText({fileKey: this.toTextItem.originUrl}).then(res => {
        console.log('res', res)
         const sentences = (res?.data?.data?.flash_result?.sentences??[]).map(item => ({...item, show:false}))
         this.timers = []
         sentences.forEach((_, i) => {
          const timer = setTimeout(() => {
            this.$set(this.chatList, i, {
              ...sentences[i],
              time: this.formatMilliseconds(sentences[i].begin_time),
              show: true
            });
            if(this.isAutoScroll) {
              this.$nextTick(() => {
                const container = this.$el.querySelector('.chat-container');
                container.scrollTop = container.scrollHeight;
              });
            }
          }, i * 300); // 300ms 间隔
          this.timers.push(timer);
        });

      })
    },
    clearAllTimers() {
      this.$nextTick(()=> {
        this.timers.forEach(time => clearTimeout(time));
        this.timers = [];
      })
    },
    handleScroll() {
      const container = this.$refs.chatContainer;
      const isNearBottom = container.scrollHeight - (container.scrollTop + container.clientHeight) < this.scrollThreshold;
      this.isAutoScroll = isNearBottom;
    },
  },
  beforeDestroy() {
    this.clearAllTimers()
  }
}
</script>

<style lang="scss" scoped>
  .chat-container {
    transition: all 0.3s;
  }
  .chat-item-wrap {
    opacity: 0;
    &::after {
      display: block;
      content: "";
      clear: both;
      overflow: hidden;
    }
  }
  .chat-item-wrap.show {
     opacity: 1;
    // transform: translateY(0);
  }
  .chat-block {
    max-width: 460px;
    box-shadow: 0 0 10px 0 rgba(78, 89, 105, .05);
    line-height: 14px;
    @apply p-3 box-border rounded-large bg-white text-theme-black-850 relative text-small float-left;
  }
  .slide-in-right {
    animation: slideInR 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  }
  .slide-in-left {
    animation: slideInL 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  }
  @keyframes slideInR {
    0% {
      transform: translateX(100%);
      opacity: 0.75;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  @keyframes slideInL {
    0% {
      transform: translateX(-100%);
      opacity: 0.75;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  .chat-block-right {
    @apply float-right bg-theme text-white;
  }
</style>